import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from '../evenementielle/components/PageHero';
import ValueProposition from './components/ValueProposition';
import ProcessSection from './components/ProcessSection';
import ConseilCta from './components/ConseilCta';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const ConseilIntro = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div
            ref={ref}
            className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
          >
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="h-px w-6 bg-brand-coral" />
              <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Pour qui ?</span>
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl text-brand-anthracite leading-tight mb-5">
              Vous souhaitez être <em className="text-brand-fuchsia">guidé</em> sans nécessairement confier tout votre projet
            </h2>
            <p className="text-brand-gray leading-relaxed mb-4">
              Notre service de conseil s'adresse aux particuliers et professionnels qui souhaitent bénéficier d'une <strong>expertise créative pointue</strong>, sans pour autant engager un projet de réalisation complet.
            </p>
            <p className="text-brand-gray leading-relaxed">
              Idéal pour les personnes qui souhaitent rénover elles-mêmes leur intérieur, préparer un événement avec les bons conseils, ou simplement clarifier leur vision avant d'investir.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: 'ri-home-2-line', label: 'Particuliers', desc: 'Rénovation ou aménagement de votre domicile' },
              { icon: 'ri-building-2-line', label: 'Entreprises', desc: 'Aménagement de bureaux et espaces professionnels' },
              { icon: 'ri-calendar-event-line', label: 'Organisateurs', desc: 'Conseils pour la décoration de vos événements' },
              { icon: 'ri-lightbulb-line', label: 'Curieux', desc: 'Vous avez une idée mais ne savez pas par où commencer' },
            ].map((t) => (
              <div key={t.label} className="bg-brand-beige rounded-xl p-5 flex flex-col gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-fuchsia/10">
                  <i className={`${t.icon} text-brand-fuchsia text-lg`} />
                </div>
                <p className="font-semibold text-brand-anthracite text-sm">{t.label}</p>
                <p className="text-brand-gray text-xs leading-relaxed">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const ConseilPage = () => (
  <>
    <title>Conseil Décoration Abidjan | Orientation & Aménagement | Ev & Co Design</title>
    <meta name="description" content="Service de conseil en décoration à Abidjan : analyse personnalisée, plan 3D, conseils couleurs et matériaux. Expertise premium sans projet complet. Ev & Co Design, Côte d'Ivoire." />
    <meta name="keywords" content="conseil décoration Abidjan, orientation aménagement intérieur Côte d'Ivoire, consultation design Abidjan" />
    <link rel="canonical" href="https://evcodesign-ci.com/conseil" />
    <meta property="og:title" content="Conseil en Décoration Abidjan | Ev & Co Design" />
    <meta property="og:description" content="Bénéficiez d'un conseil expert en décoration et aménagement à Abidjan, même sans projet complet." />
    <main className="font-sans bg-brand-beige min-h-screen">
      <Navbar />
      <PageHero
        title="Service Conseil"
        subtitle="Un accompagnement premium pour orienter vos choix en décoration et aménagement — même sans projet de réalisation complet."
        image="https://readdy.ai/api/search-image?query=interior%20design%20consultation%20meeting%20elegant%20professional%20designer%20moodboard%20color%20palette%20fabric%20samples%20modern%20studio%20Abidjan%20Africa%20warm%20lighting%20creative%20workspace&width=1920&height=800&seq=evco_conshero001&orientation=landscape"
        imageAlt="Conseil en décoration Abidjan"
        breadcrumb="Conseil"
      />
      <ConseilIntro />
      <ValueProposition />
      <ProcessSection />
      <ConseilCta />
      <Footer />
    </main>
  </>
);

export default ConseilPage;
